<template>
  <div class="app-container">
    <!--工具栏-->
    <div class="head-container">
      <el-input
        v-model="form.key"
        clearable
        placeholder="输入项目名称搜索"
        style="width: 200px"
        class="filter-item"
      />
      <el-button
        class="filter-item"
        size="mini"
        type="success"
        icon="el-icon-search"
        @click="searchKey(form.key)"
        >搜索</el-button
      >
    </div>
    <!--表单组件-->
    <!--表格渲染-->
    <el-table :data="tableData" size="small" style="width: 100%">
      <el-table-column prop="projectName" label="项目名称" />

      <el-table-column prop="projectCode" label="项目编号" />
      <el-table-column prop="partyAName" label="甲方单位名称" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="doSelect(scope.row)"
            icon="el-icon-check"
          >
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :total="total"
      style="margin-top: 8px"
      layout="total, prev, pager, next"
      @current-change="pageChange"
    />
  </div>
</template>

<script>

import {getProjectInfoPage} from '@/api/noticedetail.js'
import {
  getUserInfo,
  getUserByUid
} from '@/api/login.js'
export default {
  name: 'bpm',
  components: {},
  props: ['nItem', 'dialogName'],

  data () {
    return {
      projectQuery: {
        code: null,
        size: 10,
        page: 0,
        name: null,
        partyAName: null,
        businessUserId: null
      },
      listQuery: {
        uid: null
      },

      total: null,
      dialogFormVisible: false,
      form: {
        key: '',
        pageNum: 1
      },
      tableData: []
    }
  },
  created () {
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    async getUserInfo () {
      this.loading = true
      var res = await getUserInfo()
      if (res.status === 200) {
        this.projectQuery.userId = res.data.uid
        this.test()
      } else {
        this.$message.warning(res.msg)
      }
    },
    async test (key, page) {
      this.projectQuery.keyword = key
      this.projectQuery.page = page
      var res = await getProjectInfoPage(this.projectQuery)
      this.tableData = res.content
      this.total = res.totalElements
    },

    searchKey (key) {
      this.projectQuery.name = key
      this.test()
    },
    pageChange (e) {
      this.form.page = e
      this.test(this.form.key, e)
    },

    doSelect (data) {
          let a = {}
          a.projectSMuser = data.projectSMuser
          a.projectSMcode = data.projectSMcode
          a.projectName = data.projectName
          a.id = data.id
          a.projectCode = data.projectCode
          a.deptId = data.projectDeptId
          a.deptName = data.projectDeptName
          this.$emit('namesRes', a, this.nItem)

    }

  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/addInventory/names.vue